import React, { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import NoteDrawer from "../../components/NoteDrawer";
import "../../styles/Notes.css";
import Sidebar from "../../components/Sidebar";
import Topbar from "../../components/Topbar";


export default function Notes(dark, setDark) {
    const [sidebarOpen, setSidebarOpen] = useState(false);



    const [cookies, setCookie, removeCookie] = useCookies(['user']);
    const [notes, setNotes] = useState([]);
    const [openDrawer, setOpenDrawer] = useState(false);
    const [editingNote, setEditingNote] = useState(null);
    const [forceEdit, setForceEdit] = useState(false);

    const decodeToken = (token) => {
        try {
            const payload = token.split(".")[1];
            return JSON.parse(atob(payload));
        } catch {
            return null;
        }
    };
    const toggleTheme = () => setDark(!dark);
    const [user, setUser] = useState(null);

    useEffect(() => {
        if (!cookies.token) return;

        const decoded = decodeToken(cookies.token);
        setUser(decoded); // contient { id, username, role, ... }
    }, [cookies.token]);

    const userId = user?.userId;

    async function loadNotes() {
        const res = await fetch("https://api.industriegaming.fr/api/quebec/notes", {
            headers: {
                "Authorization": "Bearer " + cookies.token
            }
        });

        const data = await res.json();
        setNotes(data.notes || []);
    }

    useEffect(() => {
        loadNotes();
    }, []);



    return (
        <div className={`dashboard ${dark ? "dark" : ""}`}>
            <Sidebar mobileOpen={sidebarOpen} onClose={() => setSidebarOpen(false)}/>

            <div className="main">
                <Topbar
                    onToggleSidebar={() => setSidebarOpen(true)}
                    onToggleTheme={toggleTheme}
                    dark={dark}
                />
                <div className="page">

                    <div className="page-header">
                        <h1>📝 Notes</h1>

                        <button
                            className="action-btn"
                            onClick={() => {
                                setEditingNote(null);
                                setOpenDrawer(true);
                            }}
                        >
                            Nouvelle note
                        </button>
                    </div>

                    <div className="notes-grid">
                        {notes.map(note => (
                            <div key={note.id} className="note-card2" onClick={() => {
                                setEditingNote(note);
                                setOpenDrawer(true);
                            }}>
                                <div className="note-card2-header">
                                    <h3 className="note-card2-title">{note.title}</h3>

                                    <p className="note-card2-author">
                                        {note.user?.name || note.user?.email}
                                    </p>
                                </div>

                                <p className="preview">{note.content.slice(0, 120)}...</p>
                                {note.user_id === userId && (
                                    <div className="note-actions2">
                                        <button
                                            className="small-btn"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setEditingNote(note);
                                                setOpenDrawer(true);
                                                setForceEdit(true);
                                            }}
                                        >
                                            Modifier
                                        </button>

                                        <button
                                            className="small-btn delete"
                                            onClick={async (e) => {
                                                e.stopPropagation();
                                                await fetch(`https://api.industriegaming.fr/api/quebec/notes/${note.id}`, {
                                                    method: "DELETE",
                                                    headers: {
                                                        "Authorization": "Bearer " + cookies.token
                                                    }
                                                });
                                                loadNotes();
                                            }}
                                        >
                                            Supprimer
                                        </button>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>

                    <NoteDrawer
                        open={openDrawer}
                        onClose={() => {
                            setOpenDrawer(false);
                            setForceEdit(false);
                        }}
                        note={editingNote}
                        reload={loadNotes}
                        forceEdit={forceEdit}
                        dark={dark}
                    />
                </div>
            </div>
        </div>
                );
                }
